import { useState, type FormEvent } from "react";
import { TotpCodeInput } from "./TotpCodeInput";
import { errorMessage } from "./errorMessage";

export interface TotpLoginStepProps {
  // 코드를 서버에 보낸다. 거절되면 reject — 그 message 가 그대로 보인다.
  onSubmit: (code: string) => Promise<void>;
  // 「처음부터 다시」 — 비밀번호 단계로 돌아간다. 대기가 끝난 경우(여러 번 틀림·만료)도
  // 사람이 이것을 누른다; 서버 문장이 그렇게 안내한다.
  onRestart: () => void;
  title?: string;
  note?: string;
}

// 로그인의 2단계. 카드 **안**에 들어가는 조각이라 바깥 틀(.card)은 부르는 쪽 것이다 —
// 로그인 카드의 모양이 서비스마다 조금씩 달라서, 틀까지 가져오면 한쪽은 틀린다.
export function TotpLoginStep({ onSubmit, onRestart, title = "2단계 인증", note = "인증 앱에 표시된 6자리 코드를 넣어 주세요." }: TotpLoginStepProps) {
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await onSubmit(code);
    } catch (err) {
      setError(errorMessage(err, "인증하지 못했습니다. 코드를 다시 확인해 주세요."));
      setCode("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="mtotp" onSubmit={submit}>
      <h1 className="mtotp-title">{title}</h1>
      <p className="mtotp-note">{note}</p>
      <label className="b-field mtotp-field">
        <span className="b-field-label mtotp-label">인증 코드</span>
        <TotpCodeInput value={code} onChange={setCode} autoFocus disabled={busy} />
      </label>
      {error && (
        <div className="b-toast b-toast-danger mtotp-toast" role="alert">
          <div className="b-toast-text">
            <div className="b-toast-title">인증 실패</div>
            <div className="b-toast-body">{error}</div>
          </div>
        </div>
      )}
      <button className="b-btn b-btn-primary b-btn-lg mtotp-submit" type="submit" disabled={busy || code.length !== 6}>
        {busy ? "확인하는 중…" : "코드 확인"}
      </button>
      <p className="mtotp-foot">
        <button type="button" className="b-btn b-btn-ghost b-btn-sm" onClick={onRestart} disabled={busy}>
          처음부터 다시
        </button>
      </p>
    </form>
  );
}
